export const initialForm = {
  contact_name: '', company_name: '', store: '', email: '', phone: '',
  org_type: '', n_501C3: false, n_501c3_no: '', event_type: '',
  event_location: '', event_location_2: '', autocompleteLat: null, autocompleteLng: null,
  organization_promoting: '', event_date: '', event_time: '', expected_participants: '',
};

export const minimumEventDate = (today = new Date()) => {
  const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 28);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

export const validateStep = (step, form, today) => {
  const errors = {};
  const required = (field, message) => { if (!String(form[field]).trim()) errors[field] = message; };
  if (step === 1) {
    if (!/^\S+\s+\S+/.test(form.contact_name.trim())) errors.contact_name = 'Enter your first and last name.';
    required('company_name', 'Enter a company or organization name.');
    required('store', 'Select a store for pickup.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errors.email = 'Enter a valid email address.';
    if (!/^\d{10}$/.test(form.phone.replace(/\D/g, ''))) errors.phone = 'Enter a 10-digit phone number.';
  }
  if (step === 2) {
    required('org_type', 'Describe your organization.');
    if (form.n_501C3) required('n_501c3_no', 'Enter your 501C3 number.');
    required('event_type', 'Describe your event.');
    if (!form.event_location || !Number.isFinite(form.autocompleteLat) || !Number.isFinite(form.autocompleteLng)) {
      errors.event_location = 'Search for and select an event address.';
    }
  }
  if (step === 3) {
    if (form.organization_promoting.trim().length < 50) errors.organization_promoting = 'Describe promotion opportunities in at least 50 characters.';
    if (!form.event_date || form.event_date < minimumEventDate(today)) errors.event_date = 'Choose a date at least four weeks from today.';
    required('event_time', 'Enter an event time.');
    if (!form.expected_participants.trim() || !Number.isFinite(Number(form.expected_participants))) {
      errors.expected_participants = 'Enter a valid number of participants.';
    }
  }
  return errors;
};
